module.exports = __webpack_public_path__ + "img/3-2.d076cfb5.jpg";